import { useAxios } from "./../lib/AxiosProvider";
const useUtil = () => {
	const axios = useAxios();

	const LoginRequest = async (payload) => {
		const { data } = await axios.post("/admin/login", payload);
		return data;
	};
	const tokenvalidate = async (payload) => {
		const { data } = await axios.post("/admin/validate", payload);
		return data;
	};
	const AppRegistration = async (payload) => {
		const { data } = await axios.post("/admin/app-registration", payload);
		return data;
	};

	const submitSuggestion = async (payload) => {
		const { data } = await axios.post("/admin/suggestion", payload);
		return data;
	};

	const getSuggestions = async () => {
		const { data } = await axios.get("/admin/suggestions");
		return data;
	};

	const sendOtp = async (payload) => {
		const { data } = await axios.post("/otp", payload);
		return data;
	};

	const sendRegistrationOtp = async (payload) => {
		const { data } = await axios.post("/otp/registration", payload);
		return data;
	};

	const resetPasswordWithOtp = async (payload) => {
		const { data } = await axios.post("/otp/change-password", payload);
		return data;
	};

	const userSignin = async (payload) => {
		const { data } = await axios.post("/user/signin", payload);
		return data;
	};

	const validateUserToken = async (payload) => {
		const { data } = await axios.post("/user/validate-token", payload);
		return data;
	};

	const getUserProfile = async () => {
		const { data } = await axios.get("/user/profile");
		return data;
	};

	const updateUserProfile = async (payload) => {
		const { data } = await axios.put("/user/profile", payload);
		return data;
	};

	const getCommunityFeed = async ({ cursor, limit = 20, sortBy = "newest", myPostsOnly = false } = {}) => {
		const { data } = await axios.get("/user/community-feed", {
			params: {
				cursor,
				limit,
				sortBy,
				myPostsOnly,
			},
		});
		return data;
	};

	const getPublicCommunityPost = async (postId) => {
		const { data } = await axios.get(`/user/community-post/${postId}/public`);
		return data;
	};

	const createCommunityPost = async (payload) => {
		const { data } = await axios.post("/user/community-post", payload);
		return data;
	};

	const addCommentToPost = async ({ postId, text }) => {
		const { data } = await axios.post(`/user/community-post/${postId}/comment`, {
			text,
		});
		return data;
	};

	const editCommunityPost = async ({ postId, text }) => {
		const { data } = await axios.patch(`/user/community-post/${postId}`, { text });
		return data;
	};

	const editCommunityComment = async ({ postId, commentId, text }) => {
		const { data } = await axios.patch(
			`/user/community-post/${postId}/comment/${commentId}`,
			{ text }
		);
		return data;
	};

	const toggleCommunityPostLike = async ({ postId }) => {
		const { data } = await axios.post(`/user/community-post/${postId}/like`);
		return data;
	};

	const shareCommunityPost = async ({ postId }) => {
		const { data } = await axios.post(`/user/community-post/${postId}/share`);
		return data;
	};

	const getMyNotifications = async (payload = {}) => {
		const { limit = 30 } = payload;
		const { data } = await axios.get("/user/notifications", {
			params: { limit },
		});
		return data;
	};

	const markAllNotificationsRead = async () => {
		const { data } = await axios.post("/user/notifications/read-all");
		return data;
	};

	const getCommunityMembers = async (payload = {}) => {
		const { data } = await axios.post("/user/community-members-search", payload);
		return data;
	};

	const searchBloodDonors = async (payload = {}) => {
		const { data } = await axios.post("/user/blood-donor-search", payload);
		return data;
	};

	const upsertConversation = async (payload) => {
		const { data } = await axios.post("/user/chat/conversation/upsert", payload);
		return data;
	};

	const getConversations = async ({ page = 1, limit = 30 } = {}) => {
		const { data } = await axios.get("/user/chat/conversations", {
			params: { page, limit },
		});
		return data;
	};

	const getMessages = async ({ conversationId, cursor, limit = 30 }) => {
		const { data } = await axios.get(`/user/chat/messages/${conversationId}`, {
			params: { cursor, limit },
		});
		return data;
	};

	const sendMessage = async (payload) => {
		const { data } = await axios.post("/user/chat/messages", payload);
		return data;
	};

	const markConversationRead = async (payload) => {
		const { data } = await axios.post("/user/chat/messages/read", payload);
		return data;
	};

	const blockUser = async (payload) => {
		const { data } = await axios.post("/user/chat/block", payload);
		return data;
	};

	const reportUser = async (payload) => {
		const { data } = await axios.post("/user/chat/report", payload);
		return data;
	};

	return {
		LoginRequest,
		searchBloodDonors,
		tokenvalidate,
		AppRegistration,
		submitSuggestion,
		getSuggestions,
		sendOtp,
		sendRegistrationOtp,
		resetPasswordWithOtp,
		userSignin,
		validateUserToken,
		getUserProfile,
		updateUserProfile,
		getCommunityFeed,
		getPublicCommunityPost,
		createCommunityPost,
		addCommentToPost,
		editCommunityPost,
		editCommunityComment,
		toggleCommunityPostLike,
		shareCommunityPost,
		getMyNotifications,
		markAllNotificationsRead,
		getCommunityMembers,
		upsertConversation,
		getConversations,
		getMessages,
		sendMessage,
		markConversationRead,
		blockUser,
		reportUser,
	};
};

export default useUtil;
